import React, { useState } from "react";
import "../styles/Venue.css";
import ReactModal from "react-modal";
import { FaTimes } from "react-icons/fa";

const Venue = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const openImageModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  return (
    <div className="festival-container">
      <header className="festival-header1">
        <img
          src="https://makalukkaga.mpeoplesnet.com/imagesebf/img-9.png"
          alt="Tamil Nadu Govt Logo"
          className="logovenue"
        />
        <div>
          <h2 className="venuehead">தமிழ்நாடு அரசு</h2>
          <h3 className="venuesubhead">மக்கள் சிந்தனைப் பேரவை</h3>
          <h3 className="venuesubhead1">இணைந்து நடத்தும்</h3>
        </div>
        <img
          src="https://makalukkaga.mpeoplesnet.com/imagesebf/mainlogo.png"
          alt="Peravai Logo"
          className="logovenue"
        />
      </header>

      <div className="festival-content">
        <h1 className="main-title">
          22 - ஆம் ஆண்டு
          <br />
          ஈரோடு புத்தகத் திருவிழா 2026
        </h1>

        <div className="details">
          <p>
            <strong>நாள்:</strong> ஜூலை 1 முதல் ஆகஸ்ட் 11 வரை
          </p>
          <p>
            <strong>இடம்:</strong> சிக்கய்ய அரசு மற்றும் கலை அறிவியல் கல்லூரி,
            ஈரோடு
          </p>
        </div>

        <p className="motto">அனைவரும் வருக! ஆவலுடன் வருக! பயன் பெறுக!</p>

        <footer className="footer-note">மக்கள் சிந்தனைப் பேரவை, ஈரோடு</footer>
      </div>
      <div
        className="venueposter"
        onClick={() => openImageModal("/imagesebf/poster.jpg")}
      >
        <img className="venueposterimg" src="/imagesebf/poster.jpg" alt="" />
      </div>
      {/* Full Screen Image Modal */}
      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="image-modalhm"
        overlayClassName="image-modal-overlayhm"
        ariaHideApp={false}
      >
        <button className="modal-closehm" onClick={closeModal}>
          <FaTimes />
        </button>
        <img src={selectedImage} alt="Full screen" className="modal-imagehm" />
      </ReactModal>
    </div>
  );
};

export default Venue;
